// Per-client body-measurement VALUES — fully definition-based (admin catalog-driven).
// History/add are keyed by bodyMeasurementDefinitionId. The company catalog itself is managed
// via MeasurementDefinitionService.js.
//
// Migrated to the OpenAPI-generated client. The legacy functions returned the RAW axios
// response and every consumer reads `response.data` (the parsed HttpResponse envelope), so
// each function returns `{data}` — an object whose `.data` == the old `response.data`.
// Auth + X-Timezone headers are injected by configureApi's interceptor (no per-call token).

import {
    adminBodyMeasurementControllerGetLatestMeasurements,
    adminBodyMeasurementControllerGetDefinitionsForTrainee,
    adminBodyMeasurementControllerAddMeasurements,
    adminBodyMeasurementControllerGetLast7ByDefinition,
    adminBodyMeasurementControllerGetAllByDefinition,
    adminBodyMeasurementControllerDeleteMeasurement,
    adminBodyMeasurementControllerUpdateMeasurement,
    adminBodyMeasurementControllerGetMeasurementMatrix,
} from "../api/generated";

export async function getLatestMeasurements(traineeId) {
    const {data, error} = await adminBodyMeasurementControllerGetLatestMeasurements({
        path: {traineeId},
    });
    if (error) throw error;
    return {data};
}

/**
 * The definitions this trainee should be offered to log — gender-filtered + ordered by the
 * trainee's gender grid (falls back to the full catalog when the trainee has no gender).
 * Returns [{ id, name, nameHeb, imageUrl, unit, computed, displayOrder }].
 */
export async function getDefinitionsForTrainee(traineeId) {
    const {data, error} = await adminBodyMeasurementControllerGetDefinitionsForTrainee({
        path: {traineeId},
    });
    if (error) throw error;
    return {data};
}

/** Bulk upsert. `measurements` = { definitionId: value }, plus measurementDate. */
export async function addBulkMeasurements(traineeId, payload) {
    const {data, error} = await adminBodyMeasurementControllerAddMeasurements({
        path: {traineeId},
        body: payload,
    });
    if (error) throw error;
    return {data};
}

/** Last-7 history for a definition. */
export async function getLast7ByDefinition(traineeId, definitionId) {
    const {data, error} = await adminBodyMeasurementControllerGetLast7ByDefinition({
        path: {traineeId, definitionId},
    });
    if (error) throw error;
    return {data};
}

/** Full history for a definition. */
export async function getAllByDefinition(traineeId, definitionId) {
    const {data, error} = await adminBodyMeasurementControllerGetAllByDefinition({
        path: {traineeId, definitionId},
    });
    if (error) throw error;
    return {data};
}

export async function deleteMeasurement(measurementId) {
    const {data, error} = await adminBodyMeasurementControllerDeleteMeasurement({
        path: {measurementId},
    });
    if (error) throw error;
    return {data};
}

export async function updateMeasurement(measurementId, value, measurementDate) {
    const payload = { value };
    if (measurementDate) {
        payload.measurementDate = measurementDate;
    }
    const {data, error} = await adminBodyMeasurementControllerUpdateMeasurement({
        path: {measurementId},
        body: payload,
    });
    if (error) throw error;
    return {data};
}

export async function getMeasurementMatrix(traineeId) {
    const {data, error} = await adminBodyMeasurementControllerGetMeasurementMatrix({
        path: {traineeId},
    });
    if (error) throw error;
    return {data};
}
